<template>
  <div>
   <div class="vl-parent">
        <loading v-model:active="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage"/>
   </div>
     <h3 style="background:#007bff;; padding: 10px; line-height: 42px; text-align: center; color: #fff;">Volunteers</h3>
             <form class="fed_search" @submit.prevent="searchnotice()">
              <div class="form-group col-md-4">
                <label for="">District Name and Title</label>
                <input type="text" class="form-control" v-model="noticetitle" @input="searchInput"   placeholder="District Name and Title">
               <div class="productlist" v-if="federationok" ref="suggestionsList">
                <ul>
                 <li @click="selectnotice(notice.DistrictNameTitle)" v-for="notice in this.noticelist">{{notice.DistrictNameTitle}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-3">
                 <label for="">Start Date</label>
                <input type="date" class="form-control" v-model="starttime" @input="districtInput"  placeholder="Start Date">
              </div>
              <div class="form-group col-md-3">
                 <label for="">End Date</label>
                <input type="date" class="form-control" v-model="endtime" @input="upazilaInput"  placeholder="End Date">
              </div>
               <div class="form-group col-md-2">
                <button type="submit" class="fed_search_btn"><i class="fa fa-search"></i> Search</button>
              </div>          
        </form>
      <div class="table-responsive">
       <table id="order-listing" class="table">
           <thead>
               <tr>
                  <th>No</th>
                  <th>Volunteer Title</th>
                  <th>Date</th>
                  <th v-if="this.delete">Atcion</th>
               </tr>
           </thead>
               <tbody>
                  <tr v-for="(notice,index) in this.notices"> 
                    <td style="width:20px!important;">{{index+1}}</td> 
                    <td>{{notice.DistrictNameTitle}}</td> 
                    <td>{{ moment(notice.created_at).format('LLL')}}</td> 
                    <td>
						   <div class="dropdown">
						    <button @click="toggleDropdown" class="dropdown-button">Actions</button>
						    <div class="dropdown-content" v-show="isOpen">
						      <a v-if="this.delete" href="#" @click.prevent="deleteAction(notice.id)"><i class="fa fa-trash"></i> Delete</a>
						      <a target="_blank" :href="url+'volunteer/'+notice.filename" @click="viewAction"><i class="fa fa-eye"></i> View</a>
						    </div>
						  </div>	
              </td> 
            </tr> 
          </tbody>
       </table> 
       <br><br><br><br><br>
	     <transition name="modal">
		     <div v-if="showModal" class="vmodal">
		      <div class="modal-content">
		        <span @click="closeModal" class="close">&times;</span>
		        <p>Are you sure you want to delete it?</p>
		         <div class="buttons">
		            <div class="right">
		              <button @click="deleteItem" type="button" class="btn btn-danger btn-fw">Delete</button>&nbsp;&nbsp;
		              <button @click="closeModal" type="button" class="btn btn-info btn-fw">Cancel</button>
		            </div>
		          </div>
		      </div>
		    </div>
		 </transition>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import moment from 'moment';
export default{
  props:['delete'],
  components: {
    Loading
  },
  data(){
    return{
     moment,
     isLoading: false,
     fullPage: true,
     notices:[],
     isOpen: false,
     showModal: false,
     noiceid:0,
     noticelist:[],
     suggestion:false,
     noticetitle:'',
     starttime:'',
     endtime:'',
     federationok:false,
    }
  },
  computed:{
    url(){
      return this.$store.state.url;
    }

  },
  mounted(){
    document.addEventListener('click', this.pageClick);
    this.allnotices();
  },
  beforeUnmount() {
      document.removeEventListener('click', this.pageClick);
  },
  methods:{
  searchnotice(){
    this.isLoading=true;
    axios.post(this.url+'searchvolunteers',{
      noticetitle:this.noticetitle,
      starttime:this.starttime,
      endtime:this.endtime,
    }).then(response=>{
    
      this.notices=response.data; 
      this.isLoading=false;

    })
  },
  allnotices(){
     axios.get(this.url+'getallvolunteer').then(response=>{
        this.notices=response.data;
     })
  },
  pageClick(event){
      if (
           event.target !== this.$refs.inputField &&
           event.target !== this.$refs.suggestionsList
           ) {
            this.federationok = false;
            this.suggestion=false;

   }
   },
   searchInput(event){
      var notices=event.target.value;
      if(notices==''){
      this.noticelist=[];
      }else{
        axios.get(this.url+'getvolunteerlist/'+notices).then(response=>{
                this.noticelist=response.data;
         console.log(this.noticelist);
        })
        this.federationok=true;

      }

    },
    selectnotice(notice){
      this.noticetitle=notice;
    },
   toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
   deleteAction(federationid) {
      this.noiceid=federationid;
      this.isOpen = false;
      this.showModal = true;
    },
    viewAction() {
      this.$emit('view');
      this.isOpen = false;
    },
    closeModal() {
      this.showModal = false;
    },
    deleteItem() {
      this.closeModal();
      this.isLoading=true;
      axios.post(this.url+'deletevolunteer',{
      	id:this.noiceid,
      }).then(response=>{
      	toast.success("Volunteer deleted successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.allnotices();
        this.isLoading=false;

      })
    },
    
  }

}
</script>
<style scoped>
 .productlist,.productlist2,.productlist3
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul,.productlist2 ul,.productlist3 ul{
    list-style: none;
    background: rgb(0, 123, 255);
  }
  .productlist ul li,.productlist2 ul li,.productlist3 ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  .table-responsive{
  	overflow-x: hidden;
  }
  </style>
<style>
 form.fed_search {
    background: #3a3f51;
    display: block;
    width: 100%;
    float: left;
    padding: 15px;
    color: #fff;
    display: flex;
}
.fed_search_btn {
    background: #007bff;
    position: relative;
    top: 24px;
    padding: 5px 5px;
    line-height: 30px;
    border: 0px;
    width: 100%;
    color: white;
    font-size: 0.875rem;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  min-width: 160px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown-button {
  background-color: rgb(0, 123, 255);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}
</style>
<style scoped>
.vmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  width:50%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}

.button {
  margin-top: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  text-align: right;
}

.modal-enter-active, .modal-leave-active {
  transition: transform .5s ease-in, opacity .5s ease-out;
  transform: translateY(-50%);
  opacity: 1;
}
.modal-enter, .modal-leave-to /* .modal-leave-active in <2.1.8 */ {
  transform: translateY(-50%);
  opacity: 0 opacity .5s ease-out;
}

</style>
<style>
  .modal-mask2{
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper2{
    display: table-cell;
    vertical-align: middle;
  } 
  .modal-container2{
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}
.modal-header {
    padding: 5px!important;
    border-bottom: 1px solid #e5e5e5;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}
.wrappermodel{
  display: flex;

}
.lefside{
  width:48%;
  float:left;
  padding-right:10px;
}
.rightside{
   width:48%;
  float:left;
}
.modal-default-button{
  background: #007bff;
  border: 1px solid #007bff;
  color: white;
}
</style>
<style>
 form.fed_search {
    background: #3a3f51;
    display: block;
    width: 100%;
    float: left;
    padding: 15px;
    color: #fff;
    display: flex;
}
.fed_search_btn {
    background: #007bff;
    position: relative;
    top: 24px;
    padding: 5px 5px;
    line-height: 30px;
    border: 0px;
    width: 100%;
    color: white;
    font-size: 0.875rem;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  min-width: 160px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown-button {
  background-color: rgb(0, 123, 255);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}
</style>
<style scoped>
.vmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  width:50%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}

.button {
  margin-top: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  text-align: right;
}

.modal-enter-active, .modal-leave-active {
  transition: transform .5s ease-in, opacity .5s ease-out;
  transform: translateY(-50%);
  opacity: 1;
}
.modal-enter, .modal-leave-to /* .modal-leave-active in <2.1.8 */ {
  transform: translateY(-50%);
  opacity: 0 opacity .5s ease-out;
}

</style>
<style>
  .modal-mask2{
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper2{
    display: table-cell;
    vertical-align: middle;
  } 
  .modal-container2{
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}
.modal-header {
    padding: 5px!important;
    border-bottom: 1px solid #e5e5e5;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}
.wrappermodel{
  display: flex;

}
.lefside{
  width:48%;
  float:left;
  padding-right:10px;
}
.rightside{
   width:48%;
  float:left;
}
.modal-default-button{
  background: #007bff;
  border: 1px solid #007bff;
  color: white;
}
</style>